{
  "configuration.linksImMenuUnterstuetzungPublic": "Liens dans le menu information (GRUDIS Public)",
  "dashboard.rechtehinweis.legalHintMessage": "Les informations sur les immeubles qui figurent dans le système GRUDIS sont fournies sans garantie et n’ont aucun effet juridique. Les services compétents pour les thèmes des RDPPF sont visibles dans l’extrait du cadastre RDPPF.",
  "KantGid": "BE-GID",
  "layouts.page.title": "GRUDIS",
  "layouts.page.titleNavigation": "GRUDIS Navigation",
  "titel.zentralePerson": "Personne GCP"
}
